'use client';

import { GlossyBackground } from '../ui/glossy-background';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { ArrowLink } from '../ui/arrow-link';

export function CallToAction({
  title,
  description,
  button,
}: {
  title: string;
  description: string;
  button: string;
}) {
  return (
    <GlossyBackground className="gap-10">
      <div className="flex flex-wrap items-center justify-center gap-8">
        {/* <Image
          src={'/images/25+.svg'}
          alt="25+"
          width={0}
          height={0}
          className="h-auto w-[118px] object-contain sm:w-[128px] lg:w-[164px]"
        /> */}
        <Heading
          title={title}
          tag="h2"
          className={{ container: 'text-center', title: 'text-white' }}
        />
      </div>
      <Paragraph
        innerHtml={description}
        className="w-full max-w-[878px] text-center"
        color="white"
        size="base"
      />
      <ArrowLink
        title={button}
        className={{ title: 'text-white' }}
        variant={'white'}
        href="/sonicube"
      />
    </GlossyBackground>
  );
}
